// Skjemaverdier for en egen ordre og oversettelse til det createCarrierOrder/updateCarrierOrder forventer.
// Serveren (carrierOrderValidation.js) er fasit. Dette er rask feedback i skjemaet.

import { massSupportsBags, activeMassTypes } from './massCatalog';

export const supportsPackaging = (massType) => massSupportsBags(massType);

// Ny ordre starter på grus, eller første aktive type i katalogen når grus er skrudd av.
export function defaultMassType() {
  const active = activeMassTypes();
  return active.some(t => t.key === 'gravel') ? 'gravel' : (active[0]?.key ?? 'gravel');
}

const EMPTY_ADDRESS = { street: '', city: '', lat: null, lng: null };

export const EMPTY_ORDER_FORM = {
  customerId: '',
  customer: { name: '', contactName: '', phone: '', email: '' },
  pickupAddress: EMPTY_ADDRESS,
  deliveryAddress: EMPTY_ADDRESS,
  massType: 'gravel', massDescription: '', estimatedTons: '', unit: 'tons', packaging: 'bulk',
  date: '', time: '07:00', agreedPrice: '', dispatcherNote: '',
};

const pad = (n) => String(n).padStart(2, '0');
const str = (v) => (v === null || v === undefined ? '' : String(v));

export function formFromOrder(order) {
  const d = order.scheduledAt?.toDate?.() ?? null;
  const c = order.customer ?? {};
  return {
    customerId: order.customerId ?? '',
    customer: { name: str(c.name), contactName: str(c.contactName), phone: str(c.phone), email: str(c.email) },
    pickupAddress: order.pickupAddress ?? EMPTY_ADDRESS,
    deliveryAddress: order.deliveryAddress ?? EMPTY_ADDRESS,
    massType: order.massType ?? defaultMassType(), massDescription: str(order.massDescription),
    estimatedTons: str(order.estimatedTons), unit: order.unit ?? 'tons', packaging: order.packaging ?? 'bulk',
    date: d ? `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` : '',
    time: d ? `${pad(d.getHours())}:${pad(d.getMinutes())}` : '07:00',
    agreedPrice: str(order.agreedPrice), dispatcherNote: str(order.dispatcherNote),
  };
}

const hasCoords = (a) => Boolean(a?.street?.trim()) && typeof a?.lat === 'number' && typeof a?.lng === 'number';
const toTons = (v) => Number(str(v).replace(',', '.'));

export function validateOrderForm(form) {
  const errors = {};
  if (!form.customerId && !form.customer.name.trim()) errors['customer.name'] = 'Skriv inn kundens navn';
  if (!hasCoords(form.pickupAddress)) errors.pickupAddress = 'Velg hentested fra søket';
  if (!hasCoords(form.deliveryAddress)) errors.deliveryAddress = 'Velg leveringssted fra søket';
  if (!(toTons(form.estimatedTons) > 0)) errors.estimatedTons = 'Skriv inn en mengde større enn 0';
  if (!/^\d{4}-\d{2}-\d{2}$/.test(form.date) || !/^\d{2}:\d{2}$/.test(form.time)) errors.date = 'Velg dato og klokkeslett';
  const price = str(form.agreedPrice).trim();
  if (price !== '' && !/^\d+$/.test(price)) errors.agreedPrice = 'Prisen må være et heltall i kroner';
  return errors;
}

const priceOf = (form) => {
  const price = str(form.agreedPrice).trim();
  return price === '' ? null : Number(price);
};

export function payloadFromForm(form) {
  const customerPart = form.customerId
    ? { customerId: form.customerId }
    : { customer: { name: form.customer.name, contactName: form.customer.contactName, phone: form.customer.phone, email: form.customer.email } };
  return {
    ...customerPart,
    pickupAddress: form.pickupAddress, deliveryAddress: form.deliveryAddress,
    massType: form.massType, massDescription: form.massDescription,
    estimatedTons: toTons(form.estimatedTons), unit: form.unit,
    packaging: supportsPackaging(form.massType) ? form.packaging : null,
    scheduledAt: new Date(`${form.date}T${form.time}`).toISOString(),
    agreedPrice: priceOf(form), dispatcherNote: form.dispatcherNote,
  };
}

// Under transport kan bare notat og pris endres
export const notePricePayload = (form) => ({ dispatcherNote: form.dispatcherNote, agreedPrice: priceOf(form) });
